import { SdkInfo } from './sdkinfo';

export interface SdkMetadata {
  sdk?: SdkInfo;
}
